import Vue from "vue";
export default Vue.directive("microsoft-signin-button", {
  bind: (el, binding, vnode) => {
    let clientId = binding.value;

    el.addEventListener("click", () => {
      window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?
        client_id=${clientId}
        &response_type=id_token
        &redirect_uri=${encodeURIComponent(window.location.href.split("#")[0])}
        &scope=openid 
        profile email  
        User.Read
        &response_mode=fragment
        &state=12345
        &nonce=678910
        &prompt=login
        `;
    });
  }
});
